/**
 * Page Visibility helpers. These compare against 'hidden' rather than reading
 * document.hidden so that a prerendering or non-browser document counts as not
 * hidden and loads normally.
 */

/** @returns {boolean} true while this tab is in the background */
export function isTabHidden() {
  return typeof document !== 'undefined' && document.visibilityState === 'hidden';
}

/**
 * Run `fn` now, or the next time the tab is visible if it is in the background.
 * @param {Function} fn
 * @returns {void}
 */
export function runWhenVisible(fn) {
  if (!isTabHidden()) {
    fn();
    return;
  }
  const onChange = () => {
    if (isTabHidden()) return;
    document.removeEventListener('visibilitychange', onChange);
    fn();
  };
  document.addEventListener('visibilitychange', onChange);
}
